import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntityType } from 'app/types/entity';
import { ALL_TRANSLATIONS } from '../translations';
import { Configuration, IConfiguration } from './Configuration';

export interface IMeetingsConfig extends IConfiguration {
  attributes: {
    id: EntityStringId;
    supportUrl: string | null;
  }
}

export type MeetingsConfig = Entity<IMeetingsConfig>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingsConfig: IEntityType<IMeetingsConfig> = vmClient.defineClass({
  typeName: 'SiteFeature.MeetingsConfig',
  version: 1,
  persisted: true,
  extends: Configuration,
  attributes: {
    supportUrl: 'string',
  },
});

ALL_TRANSLATIONS.set(MeetingsConfig, {
  supportUrl: {
    getLabel: (t) => t('entity-fields.MeetingsConfig.supportUrl.label'),
    getDescription: (t) => t('entity-fields.MeetingsConfig.supportUrl.description'),
  },
});
